import { getFunctions, httpsCallable } from 'firebase/functions';
import { useState, useCallback } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { usePlanStore } from '../../stores/planStore';

interface ModerationRequest {
  text: string;
  context: string;
  step: string;
  action: 'next' | 'publish';
}

interface ModerationResult {
  flagged: boolean;
  blocked: boolean;
}

export interface ModerationError {
  type: 'flagged' | 'blocked' | 'api_error';
  message: string;
}

export function useModeration() {
  const [loading, setLoading] = useState(false);

  const user = useAuthStore((s) => s.user);
  const profile = useAuthStore((s) => s.profile);
  const activePlan = usePlanStore((s) => s.activePlan);

  const moderate = useCallback(
    async (params: ModerationRequest): Promise<ModerationResult> => {
      const functions = getFunctions();
      const fn = httpsCallable<object, ModerationResult>(
        functions,
        'moderateBusinessContent'
      );

      const profileAny = profile as unknown as Record<string, unknown> | null;

      setLoading(true);
      try {
        const result = await fn({
          text: params.text,
          userId: user?.uid ?? null,
          source: 'business_builder',
          context: params.context,
          planId: activePlan?.id ?? null,
          step: params.step,
          action: params.action,
          explorerName:
            profile?.displayName ??
            (profileAny?.explorerName as string | undefined) ??
            user?.displayName ??
            'Explorer',
        });
        return result.data;
      } finally {
        setLoading(false);
      }
    },
    [user, profile, activePlan]
  );

  return { moderate, loading };
}
